const today = new Date().toLocaleString('en-GB', {
  day: '2-digit',
  month: '2-digit',
  year: 'numeric',
  hour: '2-digit',
  minute: '2-digit',
})

export default `/*\nDo not edit directly\nGenerated on ${today}\n*/\n\n`
